/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react'

import { useNavigate } from 'react-router-dom';
import Carousel from "react-bootstrap/Carousel";
import { useApp } from 'contexts/AppContext'

import notify from 'components/UI/toast'
import Button from 'components/Button';
import { FormSearchAirfare } from "components/FormSearchAirfare";
import { FormSearchHotels } from "components/FormSearchHotels";
import { FormSearchCars } from "components/FormSearchCars";
import { CarouselDefault } from "components/Carousel";

import { Banner, SearchHotelsContainer } from "./styles";
import api from "../../_config/http";
import {generateRedirectUrl, validAirfare} from "./utils";
import {LoaderSmall} from "../../components/Loader";

export const TravelSearch = () => {

    const [banners, setBanners] = useState([])
    const [loading, setLoading] = useState(true)

    const [travelProduct, setTravelProduct] = useState('airfare')
    const { hotelState, carState, airfareState } = useApp()


    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const response = await api.get('/flights-home')
            if(response.status === 200) {
                setBanners(response.data)
            }
            setLoading(false)
        }

        fetchData()

    }, [])

    const handleRedirectHotelSearch = () => {
        if (!hotelState.locationSearchHotel.id) {
            notify('Por favor, insira a cidade para pesquisa', 'warn')
            return
        }
        navigate('/loja/search-hotels-result')
    }

    const handleRedirectCarSearch = () => {
        if (!carState.locationPickupCar.id) {
            notify('Por favor, insira o local para pesquisa', 'warn')
            return
        }
        navigate('/loja/search-cars-result')
    }

    const handleRedirectAirfareSearch = async () => {

        const valid = await validAirfare(airfareState)

        if (valid) {
            setLoading(true)
            let redirectUrl = await generateRedirectUrl(airfareState)
            setTimeout(() => {
                window.location.href = redirectUrl
            }, 1000)
        }

    }

    if(loading) {
        return <LoaderSmall />
    }

    return (
        <SearchHotelsContainer>
            <Banner>
                <Carousel variant="dark">
                    {banners?.banners.map((item ) => item.show_image === "1" &&
                        <Carousel.Item key={item.uuid}>
                            <img className="d-block" src={item?.image_url} alt=""/>
                        </Carousel.Item>
                    )}
                </Carousel>
            </Banner>

            <div className="container">
                <div className="card-search">

                    <h3 className="label-modal">
                        { travelProduct === 'airfare' && 'Pesquisar Passagens'}
                        { travelProduct === 'hotel' && 'Pesquisar Hotéis'}
                        { travelProduct === 'car' && 'Pesquisar Carros'}
                    </h3>

                    {/*<div className="d-flex justify-content-between">*/}
                    {/*    <div className="d-flex align-items-center gap-2">*/}
                    {/*        <input*/}
                    {/*            type="radio" value="airfare" name="check_travel" className="custom-radio" defaultChecked={true}*/}
                    {/*            onChange={(e) => setTravelProduct(e.target.value)}*/}
                    {/*        />*/}
                    {/*        <span>Passagens</span>*/}
                    {/*    </div>*/}

                    {/*    <div className="d-flex align-items-center gap-2">*/}
                    {/*        <input type="radio" value="hotel" name="check_travel" className="custom-radio"*/}
                    {/*            onChange={(e) => setTravelProduct(e.target.value)}*/}
                    {/*        />*/}
                    {/*        <span>Hotel</span>*/}
                    {/*    </div >*/}

                    {/*    <div className="d-flex align-items-center gap-2">*/}
                    {/*        <input type="radio" value="car" name="check_travel" className="custom-radio"*/}
                    {/*            onChange={(e) => setTravelProduct(e.target.value)}*/}
                    {/*        />*/}
                    {/*        <span>Carro</span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    { travelProduct === 'airfare' && (
                        <>
                            <FormSearchAirfare />

                            <div className="d-flex justify-content-center">
                                <Button
                                    onClick={() => handleRedirectAirfareSearch()}
                                    width="187px"
                                >
                                    CONTINUAR
                                </Button>
                            </div>
                        </>
                    )}

                    { travelProduct === 'hotel' && (
                        <>
                            <FormSearchHotels />

                            <div className="d-flex justify-content-center">
                                <Button
                                    onClick={() => handleRedirectHotelSearch()}
                                    width="187px"
                                >
                                    CONTINUAR
                                </Button>
                            </div>
                        </>
                    )}

                    { travelProduct === 'car' && (
                        <>
                            <FormSearchCars />

                            <div className="d-flex justify-content-center">
                                <Button
                                    onClick={() => handleRedirectCarSearch()}
                                    width="187px"
                                >
                                    CONTINUAR
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className="mt-4 ps-4">
                {banners?.flights?.national.length > 0 ?
                    <p className="fs-5 mb-3">Destinos Nacionais</p>
                : ''}
                <CarouselDefault className="nacional" slidesPerView={2.5} images={banners?.flights?.national}/>
                
                <br />

                {banners?.flights?.international.length > 0 ?
                    <p className="fs-5 mb-3">Destinos Internacionais</p>
                : ''}

                <CarouselDefault className="internacional" slidesPerView={2.5} images={banners?.flights?.international}/>
            </div>
        </SearchHotelsContainer>
    )
}